import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getHotelSalesInput,
  getHotelSaleInput,
  HotelSaleLiteModel,
  HotelSaleModel,
} from './model';

export function useGetHotelSales(
  input?: getHotelSalesInput,
  options?: UseQueryOptions<ExtendedApiResult<HotelSaleLiteModel[]>, ApiError>,
): UseQueryResult<ExtendedApiResult<HotelSaleLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getHotelSales', input?.params],
      () =>
        QueryFetchFunction({
          url: 'hotel-sales',
          params: input?.params,
        }),
      options,
    ),
    HotelSaleLiteModel,
  );
}

export function useGetHotelSale(
  input?: getHotelSaleInput,
  options?: UseQueryOptions<ApiResult<HotelSaleModel>, ApiError>,
): UseQueryResult<ApiResult<HotelSaleModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getHotelSale', input?.id],
      () => QueryFetchFunction({ url: `hotel-sales/${input?.id}` }),
      options,
    ),
    HotelSaleModel,
  );
}

export function getHotelSalesKey(input?: getHotelSalesInput) {
  return ['getHotelSales', input?.params];
}

export function getHotelSaleKey(input?: getHotelSaleInput) {
  return ['getHotelSale', input?.id];
}
